import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LabelList,
  ResponsiveContainer,
  Cell
} from "recharts";
import { Card, Badge, Modal, Button } from "react-bootstrap";

function CityBarChart() {
  const [italyData, setItalyData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("./dati_dashboard.json");
        const data = await response.json();
        const italyRegions = data.TP.paesi.ITALIA;

        const transformedData = italyRegions
          .sort((a, b) => parseFloat(b.valore) - parseFloat(a.valore))
          .slice(0, 5)
          .map((region) => ({
            regione: region.regione.replace(/\s+/g, ''), 
            numero: parseFloat(region.numero),
            valore: parseFloat(region.valore),
          }));

        setItalyData(transformedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleToggleModal = () => setShowModal(!showModal);

  const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  // Funzione unificata per il grafico
  const renderChart = (isFull) => (
    <ResponsiveContainer width="100%" height={isFull ? 500 : "100%"}>
      <BarChart
        data={italyData}
        layout="vertical"
        margin={{ top: 10, right: 60, left: 10, bottom: 10 }} // Aumentato right per le label lunghe
        barCategoryGap="20%"
      >
        <XAxis type="number" hide />
        <YAxis 
          dataKey="regione" 
          type="category" 
          axisLine={false}
          tickLine={false}
          tick={{ 
            fill: '#212529', 
            fontSize: isFull ? "0.9rem" : "0.75rem", 
            fontWeight: "bold", 
            textTransform: "uppercase" 
          }}
          width={isFull ? 150 : 100} 
        />
        <Tooltip
          cursor={{ fill: 'transparent' }}
          contentStyle={{
            borderRadius: '10px',
            border: 'none',
            boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
            fontSize: '12px'
          }}
          formatter={(value) => [formatToEuro(value), "Fatturato"]}
        />
        <Bar
          dataKey="valore"
          radius={[0, 10, 10, 0]}
          barSize={isFull ? 50 : 32}
        >
          {italyData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={index === 0 ? "#b81f25" : "#5a5a5a"} />
          ))}
          <LabelList
            dataKey="valore"
            position="right"
            offset={10}
            formatter={(value) => formatToEuro(value)}
            fill="#b81f25"
            style={{ fontSize: isFull ? "1rem" : "0.75rem", fontWeight: "900" }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );

  return (
    <>
      {/* CARD DASHBOARD */}
      <Card 
        className="card ombra card-week card-home hover-effect border-0 tp-chart-card" 
        style={{ borderRadius: '15px', padding: '1rem', cursor: 'pointer' }}
        onClick={handleToggleModal}
      >
        <div className="d-flex justify-content-between align-items-center px-3 tp-chart-header">
          <div>
            <h6 className="text-title fw-bold mb-0" style={{ letterSpacing: '1px' }}>ORDINI PER REGIONE - ITALIA</h6>
            <small className="text-muted" style={{ fontSize: '0.65rem' }}>Top 5 regioni per fatturato</small>
          </div>
<Badge
  pill
  className="tp-badge-red"
  style={{ fontSize: "0.6rem", padding: "5px 10px" }}
>
  ITALIA
</Badge>        </div>

        <div className="tp-chart-body">
          {renderChart(false)}
        </div>
      </Card>

      {/* MODALE FULLSCREEN */}
      <Modal 
        show={showModal} 
        onHide={handleToggleModal} 
        size="xl" 
        centered
        contentClassName="border-0 shadow-lg"
        style={{ borderRadius: '15px' }}
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold text-title">
            Dettaglio Vendite per Regione
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-4">Visualizzazione espansa delle performance regionali in Italia.</p>
          <div style={{ width: '100%', padding: '10px' }}>
            {renderChart(true)}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="outline-secondary" onClick={handleToggleModal}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CityBarChart;